/* Eden Pet Co. · Halloween night: decorations on every page, and a sky that keeps coming alive */
(() => {
  const H = window.EDEN && window.EDEN.halloween;
  if (!H) return;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const img = (src, cls) => { const i = document.createElement('img'); i.src = src; i.alt = ''; if (cls) i.className = cls; i.setAttribute('aria-hidden', 'true'); return i; };
  const el = (cls, parent) => { const d = document.createElement('div'); d.className = cls; d.setAttribute('aria-hidden', 'true'); if (parent) parent.appendChild(d); return d; };

  // night sky + fog behind everything
  document.body.prepend(el('hw-stars'));
  el('hw-fog', document.body); el('hw-fog hw-fog--2', document.body);

  // glowing pumpkin string lights hanging under the header (sags between hooks)
  const header = $('header.site');
  if (header) {
    const lights = el('hw-lights');
    const n = Math.max(7, Math.round(window.innerWidth / 110));
    lights.innerHTML = `<svg viewBox="0 0 1000 34" preserveAspectRatio="none" aria-hidden="true"><path d="${Array.from({ length: n }, (_, i) => { const x0 = i * 1000 / n, x1 = (i + 1) * 1000 / n; return `${i ? '' : 'M0 2 '}Q${(x0 + x1) / 2} 30 ${x1} 2`; }).join(' ')}"/></svg>`;
    for (let i = 0; i < n; i++) {
      const b = el('hw-bulb', lights);
      b.style.left = ((i + .5) * 100 / n) + '%'; b.style.top = '12px'; b.style.animationDelay = (-Math.random() * 4) + 's';
      const im = img(i % 3 === 1 ? H.candle : H.pumpkin); im.style.animationDelay = (-Math.random() * 3) + 's'; b.appendChild(im);
    }
    ($('.hw-ribbon') || header).after(lights);
  }

  // two spiders dangling from the string lights in the top corners (tap: they scurry up); no cobwebs, they crowded the page top
  const main = $('main');
  if (main) {
    main.style.position = 'relative';
    [6, 94].forEach((x) => {
      const s = document.createElement('span'); s.className = 'hw-spider'; s.style.left = x + '%'; s.setAttribute('aria-hidden', 'true');
      s.appendChild(img(H.spider)); main.appendChild(s);
      s.addEventListener('click', () => { s.classList.add('is-up'); setTimeout(() => s.classList.remove('is-up'), 2200); });
    });
  }

  // hero: a big glowing moon behind the photo, a ghost, and a glowing pumpkin patch
  $$('.hero .stage, .about-hero .stage').forEach((stage) => {
    stage.prepend(el('hw-moonbig'));
    stage.append(img(H.ghost, 'hw-ghost'));
    const patch = el('hw-pumpkins', stage); patch.append(img(H.pumpkin), img(H.pumpkin), img(H.candle));
  });
  // silhouette hillside along the bottom of the hero: graveyard tree on one side, haunted house on the other, a scarecrow keeping watch
  $$('section.hero').forEach((hero) => {
    const land = el('hw-land'); land.append(img(H.graveyard, 'hw-land__left'), img(H.skyline, 'hw-land__right'));
    hero.prepend(land); hero.appendChild(img(H.scarecrow, 'hw-scarecrow'));
  });
  // a lit haunted house on the footer's hill, and a bubbling cauldron in the email box
  const foot = $('footer.site'); if (foot) foot.prepend(img(H.house, 'hw-house'));
  $$('.join__gift').forEach((g) => { g.replaceWith(img(H.cauldron, 'hw-cauldron')); });
  $$('.banner:not(.banner--spooky)').forEach((b) => { const p = img(H.pumpkin); p.style.cssText = 'position:absolute;z-index:1;right:110px;top:26px;width:64px;animation:hwGlow 2.6s ease-in-out infinite'; b.appendChild(p); });

  // "boo!" ghost when something lands in the basket
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-add-variant], [data-kit], #pdpAdd, #pdpStickyAdd'); if (!t || reduce) return;
    const r = t.getBoundingClientRect(), g = img(H.ghost, 'hw-boo');
    g.style.left = r.left + r.width / 2 + 'px'; g.style.top = r.top - 40 + 'px';
    document.body.appendChild(g); setTimeout(() => g.remove(), 1700);
  });

  if (reduce || H.effects === false) return;
  const sky = el('hw-sky', document.body);

  // candlelight following the pointer
  if (fine) {
    const c = el('hw-candle', document.body);
    window.addEventListener('pointermove', (e) => { c.style.setProperty('--mx', e.clientX + 'px'); c.style.setProperty('--my', e.clientY + 'px'); }, { passive: true });
  }

  const loop = (fn, min, spread, first) => { const go = () => { if (!document.hidden) fn(); setTimeout(go, min + Math.random() * spread); }; setTimeout(go, first); };
  // a witch on her broom sails across the moon now and then
  loop(() => { const w = img(H.witch, 'hw-witch'); w.style.top = (8 + Math.random() * 16) + 'vh'; sky.appendChild(w); setTimeout(() => w.remove(), 9500); }, 26000, 20000, 6000);
  // a small flock of bats crosses the sky now and then
  loop(() => {
    const n = 2 + Math.floor(Math.random() * 3), y = 60 + Math.random() * window.innerHeight * .35;
    for (let i = 0; i < n; i++) {
      const b = el('hw-bat', sky);
      b.style.top = (y + i * 26 + Math.random() * 20) + 'px'; b.style.setProperty('--dy', (-40 - Math.random() * 120) + 'px');
      b.style.animationDuration = (7 + Math.random() * 4) + 's'; b.style.animationDelay = (i * .35) + 's';
      b.appendChild(img(H.bat)); setTimeout(() => b.remove(), 13000);
    }
  }, 14000, 12000, 2500);
  // autumn leaves drifting down
  loop(() => {
    const l = img(H.leaves[Math.floor(Math.random() * H.leaves.length)], 'hw-leaf');
    l.style.left = Math.random() * 100 + 'vw'; l.style.setProperty('--dx', (Math.random() * 160 - 80) + 'px'); l.style.setProperty('--rot', (Math.random() * 540 - 270) + 'deg');
    l.style.animationDuration = (9 + Math.random() * 6) + 's'; sky.appendChild(l); setTimeout(() => l.remove(), 16000);
  }, 3500, 4000, 1500);
  // embers rising from the bottom like a bonfire
  loop(() => {
    const e = el('hw-ember', sky);
    e.style.left = Math.random() * 100 + 'vw'; e.style.setProperty('--dx', (Math.random() * 80 - 40) + 'px');
    e.style.animationDuration = (5 + Math.random() * 4) + 's'; setTimeout(() => e.remove(), 10000);
  }, 700, 900, 800);
  // glowing eyes blink from a dark corner, then vanish
  loop(() => {
    const e = el('hw-eyes', sky); e.innerHTML = '<i></i><i></i>';
    const left = Math.random() < .5;
    e.style.left = left ? (2 + Math.random() * 8) + 'vw' : 'auto'; e.style.right = left ? 'auto' : (2 + Math.random() * 8) + 'vw';
    e.style.top = (40 + Math.random() * 45) + 'vh'; setTimeout(() => e.remove(), 4400);
  }, 18000, 16000, 9000);
})();
